import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { FreelancerCardInitRegion } from '../../typings/freelancers';

import './FreelancerRegionCell.css';

export interface FreelancerRegionCellProps {
    region: FreelancerCardInitRegion;
}
const BLOCK = 'freelancer-region-cell';
export class FreelancerRegionCell extends React.PureComponent<
    FreelancerRegionCellProps
> {
    render() {
        const { region, country } = this.props.region;

        return (
            <div className={Bem.cls({ block: BLOCK })}>
                <div className={Bem.cls(BLOCK, 'region')}>{region}</div>
                <div className={Bem.cls(BLOCK, 'country')}>{country}</div>
            </div>
        );
    }
}
